import PropTypes from 'prop-types';
import Container from '@components/Container';
import {
  CompletedIcon,
  CurrentIndicator,
  FutureIndicator,
} from './styles';

const V2RepetitionProgress = ({ currentIndex, repetitions }) => {
  if (repetitions <= 1) return null;

  return (
    <Container>
      {Array.from({ length: repetitions }, (_, index) => {
        if (index < currentIndex) return <CompletedIcon key={index} />;
        if (index === currentIndex) return <CurrentIndicator key={index} />;
        return <FutureIndicator key={index} />;
      })}
    </Container>
  );
};

V2RepetitionProgress.propTypes = {
  currentIndex: PropTypes.number.isRequired,
  repetitions: PropTypes.number.isRequired,
};

export default V2RepetitionProgress;